<template>
  <v-app>
    <!-- <v-container class="pa-0 ma-0"> -->
    <v-row>
      <v-col v-if="isSmall" col="12" class="pa-0 ma-0">
        <MajorCard />
      </v-col>
      <v-col lg="9" md="12" class="pa-0 ma-0">
        <v-tabs
          v-model="tabs_index"
          background-color="grey darken-3"
          color="teal lighten-1"
          dark
          slider-color="grey darken-3"
          height="70"
          id="tabs"
          class="sticky"
          centered
          center-active
          show-arrows
          @change="scroll_window()"
        >
          <v-tab
            v-for="(item, index) of tabs"
            :key="index"
            ripple
            :class="
              index == tabs_index
                ? 'subtitle-1 font-weight-bold'
                : 'subtitle-1 font-weight-light'
            "
            >{{ item.text }}</v-tab
          >
        </v-tabs>
        <v-card
          :height="header_height"
          color="grey darken-3"
          tile
          dark
          elevation="0"
        >
          <v-row justify="center" class="px-5">
            <v-col align="center">
              <div :class= "isSmall ? 'mt-8 font-weight-thin':'mt-8 display-1 font-weight-thin'">
                My name is <b>Chuanlong Zhou</b>
                <span class="ml-1"> | </span>
                <span class="ml-1 title font-weight-thin"
                  >I'm an environmental researcher and data Scientist.</span
                >
              </div>
            </v-col>
          </v-row>
        </v-card>
        <Education id="education" />
        <Research id="research" />
        <Projects id="projects" />
        <Skills id="skills" />
        <Publication id="publication" />
        <Conferences id="conferences"/>
        <Teaching id="teaching" />
        <!-- <Contact id="contact" /> -->
      </v-col>
      <v-col v-if="!isSmall" lg="3" md="12" class="pa-0 ma-0">
        <MajorCard />
      </v-col>
    </v-row>
    <Footer />
    <!-- </v-container> -->
  </v-app>
</template>

<script>
export default {
  name: "App",
  created() {
    window.addEventListener("resize", this.cal_window);
  },
  destroyed() {
    window.removeEventListener("resize", this.cal_window);
  },
  mounted() {
    this.cal_window();
    window.addEventListener("scroll", this.onScroll);
  },
  components: {
    MajorCard: () => import("@/components/major_card"),
    Footer: () => import("@/components/footer"),

    Education: () => import("@/components/content/education"),
    Research: () => import("@/components/content/research"),
    Projects: () => import("@/components/content/projects"),
    Skills: () => import("@/components/content/skills"),

    Publication: () => import("@/components/content/publication"),
    Conferences: () => import("@/components/content/conferences"),
    Teaching: () => import("@/components/content/teaching"),
    // Contact: () => import("@/components/content/contact"),
  },

  data: () => ({
    header_height: 122.8,
    scrollTimer: -1,
    tabs_index: 0,
    isSmall: false,
    tabs: [
      { text: "education", id: "education" },
      { text: "Research Experiences", id: "research" },
      { text: "Projects", id: "projects" },
      { text: "Coding Skills", id: "skills" },
      { text: "Publication", id: "publication" },
      { text: "Talks", id: "conferences" },
      { text: "Teaching", id: "teaching" },
      // { text: "Contact Me", id: "contact" },
    ],
  }),
  methods: {
    cal_window() {
      this.isSmall = window.innerWidth < 1264 ? true : false;
      this.header_height = window.innerWidth < 1778 ? 145 : 122.8;
    },
    scroll_window() {
      var div = document.getElementById(this.tabs[this.tabs_index].id);
      var scroll = div.offsetTop - 120;
      window.scroll(0, scroll);
    },
    onScroll() {
      if (this.scrollTimer != -1) {
        clearTimeout(this.scrollTimer);
        // console.log(this.scrollTimer);
      }
      this.scrollTimer = window.setTimeout(() => {
        // console.log(1);
        var y = window.pageYOffset;
        var curr = -1;
        var max_dis = 99999;
        this.tabs.forEach((t, index) => {
          if (Math.abs(y - document.getElementById(t.id).offsetTop) < max_dis) {
            max_dis = Math.abs(y - document.getElementById(t.id).offsetTop);
            curr = index;
          }
        });
        this.tabs_index = curr;
        this.scrollTimer = -1;
      }, 50);
    },
  },
};
</script>
<style>
div #tabs {
  /* outline: 0.5px solid grey; */
  border-bottom: 0.25px solid rgb(136, 136, 136);
}
div .sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 9;
}
html {
  scroll-behavior: smooth;
}
/* div {
  outline: 1px dashed blue;
} */
</style>
